
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReligionApi } from '../../../shared/nestjs/gd-only/services/religion.api';
import { RequestCreateReligionDto } from '../../../shared/nestjs/gd-only/dto/religion.dto';

/*
  Generated class for the ChangePrivacyBloc provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class ReligionBloc {
  private subscriptions: Array<Subscription> = [];
  constructor(
    public religionApi: ReligionApi,
  ) {

  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  getAllReligion() {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.religionApi.getAllReligion()
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }

  createReligion(payload: RequestCreateReligionDto) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.religionApi.createReligion(payload)
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }

  updateReligion(payload: RequestCreateReligionDto) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.religionApi.updateReligion(payload)
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }

  deleteReligion(payload: RequestCreateReligionDto) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.religionApi.deleteReligion(payload)
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }
}




// WEBPACK FOOTER //
// ./src/bloc/settings/employee-setup/religion.bloc.ts